import { newReleases } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

export default function NewReleases() {
  return (
    <section id="new" className="relative py-14 md:py-20 bg-background-50 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <SectionHeading
            eyebrow="New 新作速递"
            title="本周新作速递"
            desc="人气攀升中的新面孔，画面与剧情俱佳，抢先追更不落后。"
            align="left"
          />
          <a
            href="#contact"
            className="shrink-0 inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full bg-background-100 border border-background-200 text-sm font-bold text-foreground-700 hover:border-primary-300 hover:text-primary-600 whitespace-nowrap cursor-pointer"
          >
            想看更多
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-3 -mx-4 px-4 md:-mx-6 md:px-6 scroll-smooth">
          {newReleases.map((c) => (
            <article
              key={c.id}
              className="group w-44 md:w-52 shrink-0 rounded-2xl overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 hover:shadow-sm transition-all"
            >
              <div className="relative">
                <img
                  src={c.cover}
                  alt={`${c.title} 韩国动态漫画新作海报`}
                  className="w-full h-56 md:h-64 object-cover object-top"
                />
                <span className="absolute top-2 left-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-[11px] font-black">
                  <i className="ri-fire-fill"></i>
                  NEW
                </span>
              </div>
              <div className="p-3 md:p-4">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="text-sm md:text-base font-bold text-foreground-950 truncate">{c.title}</h3>
                  <span className="inline-flex items-center gap-0.5 text-accent-600 font-bold text-xs shrink-0">
                    <i className="ri-star-fill text-accent-500"></i>
                    {c.rating.toFixed(1)}
                  </span>
                </div>
                <p className="text-[11px] text-foreground-500 mt-1">{c.genre} · {c.author}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}